// eslint-disable-next-line filenames/match-exported
import {PossibleTypesMap} from '@apollo/client/cache';

const introspectionToPossibleTypes = (introspectionQueryResultData: any): PossibleTypesMap => {
  const possibleTypes = {} as any;

  // eslint-disable-next-line no-underscore-dangle
  introspectionQueryResultData.__schema.types.forEach((supertype: any) => {
    if (supertype.possibleTypes) {
      possibleTypes[supertype.name] = supertype.possibleTypes.map((subtype: any) => subtype.name);
    }
  });

  return possibleTypes;
};

export default introspectionToPossibleTypes;
